function searchdivtoggle() {
  $('.new-search-bar').toggle('slow', 'swing');
}

$(document).ready(function () {
  if ($('body').hasClass('template-search')) {
    searchdivtoggle();
  }
});

function searchdivtoggle() {
  const searchBar = document.getElementById('searchBar');
  const searchButton = document.getElementById('searchButton');
  const searchCloseButton = document.getElementById('SearchClose');
  const isExpanded = searchCloseButton.getAttribute('aria-expanded') === 'true';
  const searchiconButton = document.getElementById('searchBarbutton');
  const searchForm = document.getElementById('searchBar');

  if (searchForm.style.display === 'none') {
    searchForm.style.display = 'block';
    searchiconButton.setAttribute('aria-expanded', 'true');
  } else {
    searchForm.style.display = 'none';
    searchiconButton.setAttribute('aria-expanded', 'false');
  }

  if (isExpanded) {
    // Collapse the search bar
    searchBar.style.display = 'none';
    searchCloseButton.setAttribute('aria-expanded', 'false');
    searchButton.setAttribute('aria-expanded', 'false');
  } else {
    // Expand the search bar
    searchBar.style.display = 'block';
    searchCloseButton.setAttribute('aria-expanded', 'true');
    searchButton.setAttribute('aria-expanded', 'true');
  }
}
